import React from "react";

interface Props {
  msg?: string;
  data?: any;
}

export default function ErrorMsg({ msg, data }: Props) {
  if (process.env.GATSBY_NODE_ENV == null) return null;

  if (["production", "staging"].includes(process.env.GATSBY_NODE_ENV)) {
    return (
      <div style={{ width: "100%", height: "90vh" }} />
    );
  }

  return (
    <>
      <h3 style={{ color: "red" }}>{msg ?? "Error loading data"}</h3>
      {data && <pre>{JSON.stringify(data, null, 4)}</pre>}
    </>
  );
}
